import { Config } from './config';
export const Global = {
  ...Config,

  // User
  API_SET_USER_LOG: 'auth/SetUserLogged',
  API_GET_USER_LOG: 'User/UserLogged',
  API_GET_USER_ALL: 'User/GetUsers',
  API_GET_USER_INT: 'User/GetUsersInternal',
  API_GET_USER_NASS: 'User/GetUsersByExternalUnassigned',
  API_GET_USER_COMB: 'User/GetUsersByCombinated/',
  API_GET_USER_CODE: 'User/UserCode/',
  API_UPDATE_USER_LIST: 'User/UpdateUserList/',
  API_GET_USER_SIGNATURE: 'User/AuthorizedSignature/',
  API_GET_COUNTRY_BY_USER: 'User/GetCountryByUser/',
  API_GET_LIST_USER: 'User/GetListUser'
};
